export default __webpack_public_path__ + "images/logoClarityRx.d1c8d64dd3669cfe33c9f7f87802c4c3.svg"